import { useMutation, useQueryClient } from '@tanstack/react-query'
import client from '@/client'
import {
  NOTIFICATION_ENDPOINT,
  NOTIFICATION_INVALIDATE_KEYS,
  NOTIFICATION_QUERY_KEYS
} from '../constants/notification.constants'
import type { CustomEnvelope, NotificationReadResult } from '../types/notification.types'

export const actionMarkAllNotificationsReadRequest = { method: 'POST', path: NOTIFICATION_ENDPOINT.readAll } as const

/** CUSTOM-NESTJS — tandai semua notifikasi belum dibaca milik user aktif sebagai dibaca. */
export async function actionMarkAllNotificationsRead(): Promise<NotificationReadResult> {
  const response = await client.api.post<CustomEnvelope<NotificationReadResult>>(
    actionMarkAllNotificationsReadRequest.path
  )
  return response.data.data
}

export function useActionMarkAllNotificationsRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: NOTIFICATION_QUERY_KEYS.mutation('markAllRead'),
    mutationFn: actionMarkAllNotificationsRead,
    onSuccess: () => {
      NOTIFICATION_INVALIDATE_KEYS.forEach(queryKey => queryClient.invalidateQueries({ queryKey: [...queryKey] }))
    }
  })
}
